// extracted by mini-css-extract-plugin
module.exports = {"button":"Auth_button__1XLaG","container":"Auth_container__3e8JN"};